var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/dagre/~/lodash/_Symbol.js
// module id = 175
// module chunks = 0